import React from 'react';
import { teachingSituations } from '../data/content';
export function TeachingSituations() {
  return <section className="bg-white px-4 py-6 md:px-12 md:py-8" data-id="element-189" data-mp="1eeie4uamy551">
      <h2 className="mx-auto max-w-[600px] text-center font-heading text-[22px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[30px]" data-id="element-190" data-mp="1s53x0j03af2x">
        Designed for the challenges AAC professionals work with
      </h2>
      <ul className="mt-4 divide-y divide-line border-y border-line" data-id="element-191" data-mp="2228lipheqmmw">
        {teachingSituations.map(s => <li key={s.title} className="grid gap-1 py-3 md:grid-cols-[240px_1fr] md:gap-6" data-id="element-192" data-mp="1x3f7mvy7ktm7">
            <h3 className="font-heading text-[14px] font-extrabold uppercase leading-tight text-brand md:text-[15px]" data-id="element-193" data-mp="2b2yb3bg2rgs6">
              {s.title}
            </h3>
            <p className="text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-194" data-mp="gpp17ijm9t9e">{s.text}</p>
          </li>)}
      </ul>
      <p className="mt-3.5 text-center font-heading text-[13px] font-extrabold uppercase leading-tight text-goldDark md:text-[15px]" data-id="element-195" data-mp="cp56elmin1qf">
        Specialized resources for the complexity of real AAC practice.
      </p>
    </section>;
}